import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHipchatComponent } from './simple-icons-hipchat.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHipchatComponent ],
    exports:      [ SimpleIconsHipchatComponent ],
    bootstrap:    []
})
export class SimpleIconsHipchatModule {}
